import PeterBrandt from "../../images/bitcoin-live/PeterBrandt.png";
import MarkDukas from "../../images/bitcoin-live/Mark_Dukas.png";
import BobLoukas from "../../images/bitcoin-live/Bob_Loukas.png";
import Bigcheds from "../../images/bitcoin-live/big_cheds.jpg";
import Aksel from "../../images/bitcoin-live/aksel.jpg";
import Clight from "../../images/bitcoin-live/cLight.jpg";
import OnChain from "../../images/bitcoin-live/onChain.jpg";

export const analysts = [
  {
    name: "Peter brandt",
    profilePic: PeterBrandt,
    introVideo: "ao801kn4jq",
    content: ["Multiple Published Books", "Sharing Decades of Experience"],
    twitterUrl: "https://twitter.com/PeterLBrandt"
  },
  {
    name: "Mark Dukas",
    profilePic: MarkDukas,
    introVideo: "9s59v6fn02",
    content: ["Algorithmic Trading", "Deep Crypto Experience"],
    twitterUrl: "https://twitter.com/btcsmartmoney"
  },
  {
    name: "Bob Loukas",
    profilePic: BobLoukas,
    introVideo: "bu0ko5o3i1",
    content: ["25+ Years trading", "4 Year Cycle Founder"],
    twitterUrl: "https://twitter.com/BobLoukas"
  },
  {
    name: "Big Cheds",
    profilePic: Bigcheds,
    introVideo: "vmjliqu7s0",
    content: [
      "Author best selling book “Trading Wisdom”",
      "Trading +15 years, newbie helper and chart nerd"
    ],
    twitterUrl: "https://twitter.com/BigCheds"
  },
  {
    name: "Aksel Kibar",
    profilePic: Aksel,
    introVideo: "",
    content: [
      "CMT - Classical Charting Expert",
      "Former Fund Manager",
      "Global Capital Markets Experience"
    ],
    twitterUrl: "https://twitter.com/TechCharts"
  },
  {
    name: "CtheLightTrading",
    profilePic: Clight,
    introVideo: "f0qcojuv4c",
    content: [
      "25+ Years Trading Experience",
      "Elliott Wave Hybrid strategy",
      "Position Trader"
    ],
    twitterUrl: "https://twitter.com/canuck2usa"
  },
  {
    name: "On-Chain College",
    profilePic: OnChain,
    introVideo: "",
    content: ["On-Chain Analyst", "Observer of Trends", "Verified Author"],
    twitterUrl: "https://twitter.com/OnChainCollege"
  }
];
